<!-- body starts-->
<section class="body-wrapper">
    <div class="ashton-section">
        <div class="ashton-detail cf">
        	<div class="container">
	            <div class="ashton-signup-detail cf">
	                <div class="ashton-signup-left-form">
	                	<div class="ashton-signup-form-box-detail cf">
	                		<div class="ashton-signup-form-top">
	                			<div class="ashton-signup-form-top-left">
	                				<div class="ashton-signup-form-top-left-image">
	                					<img src="assets/images/Bitmap-icon.png">
	                				</div>
	                				<div class="ashton-signup-form-top-left-titel">
	                					Ashton United FC
	                				</div>
	                			</div>
	                			<div class="ashton-signup-form-top-right">
	                				<a routerLink="/singup">
	                					New User? Sign Up
	                				</a>
	                			</div>
	                		</div>
	                		<h2>Sign in</h2>
	                		<!--<div class="ashton-signup-form-social-icon-box">
	                			<p>Sign in via</p>
	                			<ul>
	                				<li><a (click)="socialSignIn('google')"><img src="assets/images/ggole.svg"></a></li>
	                				<li><a (click)="socialSignIn('facebook')"><img src="assets/images/facebbok.svg"></a></li>
	                			</ul>
	                		</div>-->
	                		<div class="ashton-signup-form-box">
	                        <http-message [type]="'error'" [data]="loginError" *ngIf="loginError" class="err-msg-block"></http-message>    
	                        <form #singinForm="ngForm" (ngSubmit)="doLogin(singinForm)" class="signupform"> 
	                            <div class="form-group-right">
	                              <div class="login-box ashton-signup-form-input-bottom">
	                                <app-form-field validation="required|email" name="email" [(ngModel)]="loginRequest.email" class="app-group">
	                                  <input appFieldInput type="text" class="form-control login-input-style" placeholder="Email Address" tabindex="4" id="login_email">
	                                </app-form-field>
	                              </div>
	                            </div>
	                            <div class="form-group-left">        
	                              <div class="form-group">
	                                <div class="login-box ashton-signup-form-input-bottom">
	                                  <app-form-field validation="required" name="password" [(ngModel)]="loginRequest.password" class="app-group">
	                                    <input appFieldInput type="password" class="form-control login-input-style" placeholder="password" tabindex="5" id="login_password">
	                                  </app-form-field>
	                                </div>
	                              </div>
	                            </div>
	                            <div class="signup-btn ashton-signup-form-btn">
	                              <button type="submit">Sign In</button>
	                             </div>
	                        </form>
	                			<!-- <div class="ashton-signup-form-input">
	                				<div class="ashton-signup-form-input-top">
	                					<div class="ashton-signup-form-input-label">
	                						<label>Email Address</label>
	                					</div>
	                				</div>
	                				<div class="ashton-signup-form-input-bottom">
	                					<input type="text" name="">
	                				</div>
	                			</div>
	                            <div class="ashton-signup-form-input">
	                				<div class="ashton-signup-form-input-top">
	                					<div class="ashton-signup-form-input-label">
	                						<label>Password</label>
	                					</div>
	                					<div class="ashton-signup-form-forgot">
	                						<a href="#">Forgot Password?</a>
	                					</div>
	                				</div>
	                				<div class="ashton-signup-form-input-bottom">
	                					<input type="text" name="">
	                				</div>
	                			</div>
	                			<div class="ashton-signup-form-btn">
	                				<a href="#">Sign In</a>
	                			</div> -->

       
	                		</div>
	                	</div>
	                </div>
	                <div class="ashton-signup-right">
	                	<div class="ashton-signup-right-image">
	                		<img src="assets/images/pl.png">
	                	</div>
	                </div>
	            </div>
	        </div>
            <div class="overlay-video">
               
            </div>
        </div> 
    </div>
</section><!-- body ends-->
